import { Component, Input } from '@angular/core';

import { CardCollectionSectionCms } from '~/cms/interfaces/homepage.cms.interface';

@Component({
  selector: 'app-cms-card-collection-section',
  templateUrl: './card-collection-section.component.html',
})
export class CmsCardCollectionSectionComponent {
  @Input() public section: CardCollectionSectionCms;
}
